(() => {
  const GOLD = '#c9a86a';
  const BLACK = '#000000';

  function styleShopButton() {
    const account = document.querySelector('shopify-account');

    if (!account || !account.shadowRoot) return;

    const shopLogin = [...account.shadowRoot.querySelectorAll('*')]
      .find((element) =>
        element.tagName.toLowerCase() === 'shop-login'
      );

    if (!shopLogin || !shopLogin.shadowRoot) return;

    shopLogin.shadowRoot.querySelectorAll('button').forEach((button) => {
      const text = button.textContent
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!text.includes('sign in with shop')) return;

      button.style.setProperty('background', GOLD, 'important');
      button.style.setProperty('background-color', GOLD, 'important');
      button.style.setProperty('border-color', GOLD, 'important');
      button.style.setProperty('color', BLACK, 'important');

      button.querySelectorAll('*').forEach((element) => {
        element.style.setProperty('color', BLACK, 'important');
        element.style.setProperty('fill', BLACK, 'important');
      });
    });
  }

  styleShopButton();

  setInterval(styleShopButton, 500);
function styleAccountInitials() {
  const account = document.querySelector('shopify-account');

  if (!account || !account.shadowRoot) return;

  const initials = account.shadowRoot.querySelector(
    '.account-button__avatar-initials'
  );

  if (initials) {
    initials.style.setProperty('color', '#C9A86A', 'important');
  }
}

styleAccountInitials();
setInterval(styleAccountInitials, 500);
})();
